import React, { useEffect, useState } from 'react';

import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Fragment } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import SweetAlert from 'react-bootstrap-sweetalert';

import { useParams, useSearchParams } from 'react-router-dom';

import ProgAnalisis from 'components/Tvendo/Reports/AnalisisProgramming/List';
import MapView from 'components/Tvendo/Reports/AnalisisProgramming/MapView';
import { Toasty, useToasty } from 'hooks/Toasty';
import { wsRemove } from 'services/WService';

//Tabs
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import { wsFindBy } from 'services/WService';
import { TextField } from '@material-ui/core';
import moment from 'moment';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';

import Button from 'components/CustomButtons/Button.js';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { wsGetAll } from 'services/WService';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import MultiComplete from 'components/Tvendo/Common/MultiComplete';

const useStyles = makeStyles(styles);

export default function () {
  const claseStyleTab = useStyleTabs();
  const classes = useStyles();
  const [searchParams] = useSearchParams();

  const [value, setValue] = useState(0);
  const [notify, showNotify] = useToasty();
  const [firstDate, setFirstDate] = useState(searchParams.get('date') || moment().format('YYYY-MM-DD'));
  const [lastDate, setLastDate] = useState(searchParams.get('date') || moment().format('YYYY-MM-DD'));
  const [checked, setChecked] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [valueSearch, setValueSearch] = useState({});
  const [dataChanging, setDataChanging] = useState([]);

  const themeTab = useTheme();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  function handleChangeDC(field, value) {
    setDataChanging(prev => ({
      ...prev,
      [field]: value,
    }));
  }

  const [alert, setAlert] = useState(null);
  const hideAlert = () => {
    setAlert(null);
  };
  function confirm(entity, id, reload) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="Esta seguro de eliminar!"
        onConfirm={() => {
          remove(entity, id, reload);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  async function remove(entity, id, reload) {
    let response = await wsRemove(entity, id);
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  //#region Listados de api
  const [analysis, setAnalysis] = useState([]);
  const [zone, setZone] = useState([]);
  const [layers, setLayers] = useState([]);
  const [selectedLayers, setSelectedLayers] = useState([]);
  const [route, SetRoute] = useState([]);

  async function listAnalysis(filter) {
    setDataLoading(true);
    let response = await wsFindBy('prog/program-analysis', filter);
    setDataLoading(false);
    if (response.success) setAnalysis(response.data);
  }

  async function listZone() {
    setDataLoading(true);
    let response = await wsGetAll('base/zone');
    setDataLoading(false);
    if (response.success) setZone(response.data);
  }

  async function listLayer() {
    setDataLoading(true);
    let response = await wsGetAll('base/layer');
    setDataLoading(false);
    if (response.success) setLayers(response.data);
  }

  useEffect(() => {
    if (checked) {
      const filter = {
        first_date: firstDate,
        last_date: lastDate,
      };

      if (dataChanging.base_zone_id) {
        filter.base_zone_id = dataChanging.base_zone_id;
      }

      if (selectedLayers && selectedLayers.length > 0) {
        filter.base_layer_id = selectedLayers.map(layer => layer.id);
      }

      listAnalysis(filter);
    }
  }, [checked, firstDate,lastDate, dataChanging.base_zone_id, selectedLayers]);

  // console.log("CAPAS SELECCIONADAS:", selectedLayers)
  useEffect(() => {
    if (checked) {
      listZone();
      listLayer();
    }
  }, [checked]);

  // useEffect(() => {
  //     listRoute();
  // }, []);

  let tabs = [
    <Tab label="Listado" {...indexTab(0)} />,
    <Tab label="Rutas" {...indexTab(1)} />,
  ];

  let tabPanels = [
    <TabPanel value={value} index={0} dir={themeTab.direction}>
      <ProgAnalisis
        showNotify={showNotify}
        confirm={confirm}
        analysisData={analysis}
        dataLoading={dataLoading}
        setDataLoading={setDataLoading}
        valueSearch={valueSearch}
        listAnalysis={listAnalysis}
      />
    </TabPanel>,
    <TabPanel value={value} index={1} dir={themeTab.direction}>
      <MapView
        route={route}
        SetRoute={SetRoute}
        analysisData={analysis}
        // setFNReport={setFNReport}
        // fileReports={fileReports}
        // reload={getFileNumberReport}
      />
    </TabPanel>,
  ];

  return (
    <Fragment>
      <Toasty action={notify} />
      {alert}
      <Fragment>
        {!checked ? (
          <>
            <FilterCustom
              getFilter={listAnalysis}
              getValueSearch={(value) => {
                setValueSearch(value);
              }}
              date
              layer
              zone
              labelDate="Fecha Programación"
              dateField="program_date"
            />
          </>
        ) : 
        <>
          {/* <div style={{ display: 'flex', gap: '20px', marginBottom: '10px', alignItems: 'center' }}> */}
          <GridContainer style={{ display: 'flex', alignItems: 'center' }}>
            <GridItem md={1}>
              <TextField
                type="date"
                label="Primera Fecha"
                name="first_date"
                value={firstDate}
                onChange={(e) => {
                  const value = e.target.value;
                  setFirstDate(value);
                  setValueSearch((prev) => ({
                    ...prev,
                    first_date: value,
                  }));
                }}
                InputLabelProps={{ shrink: true }}
              />
            </GridItem>
            <GridItem md={1}>
              <TextField
                type="date"
                label="Última Fecha"
                name="last_date"
                value={lastDate}
                onChange={(e) => {
                  const value = e.target.value;
                  setLastDate(value);
                  setValueSearch((prev) => ({
                    ...prev,
                    last_date: value,
                  }));
                }}
                InputLabelProps={{ shrink: true }}
              />
            </GridItem>
            <GridItem md={2}>
              <Autocomplete
                options={zone}
                getOptionLabel={(item) => `${item.description}`}
                renderInput={(params) => (
                  <TextField {...params} label="Zona" margin="normal" />
                )}
                onChange={(e, item) => {
                  handleChangeDC('base_zone_id', item ? item.id : null); 
                }}
                value={zone.find(z => z.id === dataChanging.base_zone_id) || null}
              />
            </GridItem>
            <GridItem md={2}>
              <MultiComplete
                label="Capas"
                textField="name"
                selectAll
                limitTags={1}
                options={layers}
                selected={selectedLayers}
                setSelected={setSelectedLayers}
              />
            </GridItem>
          </GridContainer>
          {/* </div> */}
        </>
        }

        <Button
          size="sm"
          color={ checked ? 'info' : 'danger'}
          onClick={() => {
            setChecked(!checked);
            setValueSearch({});
          }}
        >
          {checked ? 'Fecha' : 'Comparar'}
        </Button>
        <div className={claseStyleTab.root}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              textColor="secondary"
              aria-label="Tabs"
              indicatorColor="secondary"
            >
              {tabs}
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={themeTab.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            {tabPanels}
          </SwipeableViews>
        </div>
      </Fragment>
    </Fragment>
  );
}
